import { Component, Injectable, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Injectable()
export class PleModalDataService {
  content: string;
  title: string;
  subtitle: string;
  cancel: string;
  approve: string;
  actionCallback;
}


@Component({
  selector: 'ple-modal',
  templateUrl: './ple-modal.component.html',
  styleUrls: ['./ple-modal.component.scss']
})
export class PleModalComponent implements OnInit {

  title: string;
  subtitle: string;
  content: string;
  cancel: string;
  approve: string;
  hideCancel:boolean;

  constructor(
    public dialogRef: MatDialogRef<PleModalComponent>, private _pleModalDataService: PleModalDataService) { }

  ngOnInit() {
    this.content = this._pleModalDataService.content;
    this.title = this._pleModalDataService.title;
    this.subtitle = this._pleModalDataService.subtitle;
    this.cancel = this._pleModalDataService.cancel;
    this.approve = (typeof(this._pleModalDataService.approve) === 'undefined')? 'Agree': this._pleModalDataService.approve;
    this.hideCancel = (typeof(this._pleModalDataService.cancel) === 'undefined')? true: false;
  }

  cancelClick(): void {
    this.dialogRef.close();
    this._pleModalDataService.actionCallback('Cancel');
  }

  primaryClick() {
    this._pleModalDataService.actionCallback('Ok');
  }

}
